import { IsoLanguageCodes } from '../types';

const CONSULTATION_FORM_URLS: Record<string, string> = {
  [IsoLanguageCodes.en]:
    'https://cowbellcyber.jotform.com/250276951573968?&isIframeEmbed=1&parentURL=https://console.cowbellcyber.ai',
  [IsoLanguageCodes.eu]:
    'https://cowbellcyber.jotform.com/250844433743963?&isIframeEmbed=1&parentURL=https://console.cowbellcyber.co.uk',
  [IsoLanguageCodes.au]:
    'https://cowbellcyber.jotform.com/253165812354961?&isIframeEmbed=1&parentURL=https://console.cowbell.au',
};

export function getConsultationJotFormUrl(isoLanguageCode?: string | null): string {
  const code = isoLanguageCode ?? IsoLanguageCodes.en;
  return CONSULTATION_FORM_URLS[code] ?? CONSULTATION_FORM_URLS[IsoLanguageCodes.en];
}
